<template>
  <div class="container">
    <div style="text-align: center; margin-bottom: 0px;">
      <!-- <h1 style="color: #313e5e; font-weight: bold; margin-bottom: 0px;">PERMOHONAN</h1> -->
      <!-- <h1 style="color: #313e5e; font-weight: bold; margin-bottom: 15px;">DESAIN INDUSTRI</h1> -->
    </div>
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <card class="card-login card-white">
            <template slot="header">
              <img src="img/logo-ki-web.jpg" alt="" />
              <h1
                class="card-title"
                style="padding-left: 5px; visibility: hidden"
              >
                LOGIN <br />
              </h1>
              <br />
            </template>

            <div>
              <ValidationProvider
                name="userid"
                rules="required"
                v-slot="{ passed, failed, errors }"
              >
                <base-input
                  style="
                    font-size: 17px !important;
                    background-color: #ffffff !important;
                  "
                  required
                  v-model="userid"
                  placeholder="User ID"
                  addon-left-icon="tim-icons icon-single-02"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                >
                </base-input>
              </ValidationProvider>

              <ValidationProvider
                name="password"
                rules="required|min:5"
                v-slot="{ passed, failed, errors }"
              >
                <base-input
                  style="
                    font-size: 17px !important;
                    background-color: #ffffff !important;
                  "
                  required
                  v-model="password"
                  placeholder="Password"
                  addon-left-icon="tim-icons icon-lock-circle"
                  type="password"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                >
                </base-input>
              </ValidationProvider>
              <div>
                <div class="d-flex justify-content-between">
                  <span>
                    <router-link style=" color: #313e5e;" to="/login/forgetpass">Lupa Password</router-link>
                  </span>
                  <!-- <span>
                    <router-link style="    color: #313e5e;" to="/login/activatelogin">Aktivasi Akun</router-link>
                  </span> -->
                </div>

                <div class="d-flex justify-content-between">
                  <span>
                    <router-link style="    color: #313e5e;" to="/daftar-akun">Daftar Akun</router-link>
                  </span>
                  <span>
                    <router-link style="    color: #313e5e;" to="/login/reactivatelogin">Reaktivasi Akun</router-link>
                  </span>
                </div>
              </div>
            </div>

            <div slot="footer">
              <base-button
                native-type="submit"
                type="primary"
                class="mb-3"
                size="lg"
                block
                style="
                  color: #313e5e !important;
                  border: 0.2px solid #313e5eb !important;
                "
              >
                LOGIN
              </base-button>
            </div>
          </card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import api from "./api";
import swal from "sweetalert2";
import auth from "../../util/auth";
import { Loading } from 'element-ui'

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  components: {
    [Loading.name]: Loading
  },
  data() {
    return {
      userid: "",
      password: "",
      subscribe: true,
    };
  },
  methods: {
    submit() {
      const loadprg = Loading.service({
        fullscreen: true,
        spinner: 'el-icon-loading',
        lock: true,
        text: 'Verifikasi ID & Password Pengguna...Mohon ditunggu'
      });

      api
        .login(this.userid.toString().trim(), this.password.toString().trim())
        .then((userapp) => {
          if (userapp.data.length > 0) {
            if (userapp.data[0].IND_INACTIVE == 'N') {
              auth.setlogin(userapp.data[0]);
              this.$router.push({ path: "/buat-pengajuan?login=1" });
              //this.$router.push({ path: "/user-docx/tp/pasca-sertifikat" });
            } else if (userapp.data[0].IND_INACTIVE == 'S') {
              return swal.fire({
                title: "Login",
                text: 'Anda belum melakukan aktivasi, silahkan cek email anda!',
                icon: "error",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              });
            } else {
              return swal.fire({
                title: "Login",
                text: 'Status user belum aktif',
                icon: "error",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              });
            }
          } else {
            var errLogin = "User ID tidak ditemukan!"
            if (userapp.isUser == true) errLogin = "Password anda salah !!";
            swal.fire({
              title: "Login",
              text: errLogin,
              icon: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          }
        }).finally(() => {
          loadprg.close()
        });
    //   loadprg.close();
    },
  },
  mounted() {
    auth.checkCookies();
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
input.form-control {
  font-size: 17px !important;
}
</style>
